import React from "react";
import PageShell from "@/components/site/PageShell";
import HeroRaquel from "@/components/home/HeroRaquel";
import RadarPreview from "@/components/home/RadarPreview";
import PerguntaCentral from "@/components/home/PerguntaCentral";
import Investigacao from "@/components/home/Investigacao";
import Retroalimentacoes from "@/components/home/Retroalimentacoes";
import LimitesHumano from "@/components/home/LimitesHumano";
import ValorBlock from "@/components/home/ValorBlock";
import PublicacoesPreview from "@/components/home/PublicacoesPreview";
import DocenciaBlock from "@/components/home/DocenciaBlock";
import { Pratica } from "@/components/home/Pratica";
import { SobreContato } from "@/components/home/SobreContato";

const SECTIONS = [
    "hero", "radar", "pergunta", "investigacao", "valor", "retro", "limites",
    "publicacoes", "docencia", "pratica", "contato",
];

const HomePage = () => (
    <PageShell path="/" sections={SECTIONS}>
        <HeroRaquel />
        <RadarPreview />
        <PerguntaCentral />
        <Investigacao />
        <ValorBlock />
        <Retroalimentacoes />
        <LimitesHumano />
        <PublicacoesPreview />
        <DocenciaBlock />
        <Pratica />
        <SobreContato />
    </PageShell>
);

export default HomePage;
